import i18n from 'i18next';

export const GENRES_SELECT_OPTIONS = [
	{ name: i18n.t('vod_section_details_all_movies_and_series'), id: 'all' }
];
